'use strict';

module.exports = ['$http',
    function ($http) {

        return {
            restrict: 'E',
            scope: {
                form: '=',
                name: '=',
                title: '=',
                model: '=',
                pbreadonly: '=',
                details: '=',
                options: '='
            },
            templateUrl: '/partial/app.directives.instagram_tag',
            link: function (scope, element, attributes) {
                scope.checkTag = () => {
                    //TODO: API Call

                }
            }
        };
    }
];

